import React, {Component} from 'react';
import PropTypes from 'prop-types';
//import LimitOrder from './LimitOrder';
import OrderBookRow from './OrderBookRow';
import MarketOrders from './MarketOrders';
import * as firebase from 'firebase';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

const quips = ["Calling in favors...", "Embezzling Funds...", "Betting against USD...", "Misplaced your cash...", "On the phone with the SEC..."];

/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */
class OrderbookContainer extends Component {
    constructor(props) {
        //console.log("OrderbookContainer created");
        super(props);
        this.state = {
            orders: [],
            // midPoints: [],
            paused: false,
            LastPrice: '-',
            priceTimes: 0,
            focused: false,
            auctionStrike: 20.00,
            auctionOnly: true,
            inAuction: false,
            quip: quips[Math.floor(Math.random() * quips.length)],
            userSums: {"Bid":{},"Ask":{}},
            orderBookSums: {"Bid":{},"Ask":{}}
        };

        this.userValues = {};
        this.orderBookValues = {};
        this.strikes=[];

        this.vwapRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC");

        this.vwapRef.once('value', snap => {
          console.log("VWAP",snap.val());
          if (snap.val()) {
              this.setState({
                  LastPrice: ((parseFloat(snap.val().CurrentAssetPrice) + 25) / 100).toFixed(2),
                  priceTimes: 1
              });
          } else {
              this.setState({
                  LastPrice: '20.00'
              });
          }
          console.log(this.state.LastPrice);
        });

    }

    //sets quip state to display quips on a timer
    getQuip() {
        //console.log("OrderbookContainer getQuip");
        this.setState({
            quip: quips[Math.floor(Math.random() * quips.length)]
        })
    }

    auctionOnlyClick() {
      this.setState({
        auctionOnly: !this.state.auctionOnly
      });
    }

    updateAuctionStrike(){
      let bids = this.state.orderBookSums.Bid;
      let asks = this.state.orderBookSums.Ask;
      let strikes = Object.keys(bids);
      let matches = [];
      strikes.map(strike=>{
        if (asks.hasOwnProperty(strike)){
          if (asks[strike] > 0 && bids[strike] > 0){
            matches.push([strike, Math.min(asks[strike], bids[strike])]);
          }
        }
      });
      if (matches.length === 0){
        this.setState({auctionStrike: "-"});
        return;
      }
      let maxStrikes = [];
      let maxVal = 0;
      let diffSpread = 10000000;
      matches.map(pair=>{
        let val = pair[1];
        if (val > maxVal){
          maxVal = val;
          maxStrikes = [pair[0]];
          diffSpread = Math.abs(bids[pair[0]] - asks[pair[0]]);
        } else if (val == maxVal){
          var tempDiff = Math.abs(bids[pair[0]] - asks[pair[0]]);
          if (diffSpread > tempDiff){
            maxStrikes = [pair[0]];
            diffSpread = tempDiff;
          } else if (diffSpread == tempDiff){
            maxStrikes.push(pair[0]);
          }
        }
      });
      if (maxStrikes.length == 1){
        this.setState({auctionStrike: maxStrikes[0]});
        return;
      }

      maxStrikes.sort();
      let winner = maxStrikes[Math.floor(maxStrikes.length/2)];
      this.setState({auctionStrike: winner});
      return;
    }

    setAuctionRowValue(dataObj){
      var that = this;
      let calculateSums = function(obObj, orderType){
        var strikes = [...new Set([...Object.keys(obObj) ,...that.strikes])];
        strikes.sort(); //low to high
        var response = {};
        if (orderType == "Bid"){
          strikes.reverse();
        }
        var prev = 0;
        strikes.forEach(strike=>{
          if (obObj.hasOwnProperty(strike)){
            response[strike] = prev + parseInt(obObj[strike][orderType] || 0);
            prev = response[strike];
          } else {
            response[strike] = prev;
          }
        });
        return response;
      }

      if (dataObj.hasOwnProperty("shortcut")){
        let orderBookSums = Object.assign({}, this.state.orderBookSums);
        orderBookSums["Bid"] = calculateSums(this.orderBookValues, "Bid");
        orderBookSums["Ask"] = calculateSums(this.orderBookValues, "Ask");
        this.setState({orderBookSums});
        this.updateAuctionStrike();
        return;
      }

      if (dataObj.hasOwnProperty("shortcutuser")){
        let userSums = Object.assign({}, this.state.userSums);
        userSums["Bid"] = calculateSums(this.userValues, "Bid");
        userSums["Ask"] = calculateSums(this.userValues, "Ask");
        this.setState({userSums});
        return;
      }

      let strike = dataObj.strike;
      let isUser = dataObj.isUser;
      let newValue = dataObj.newValue;
      let orderType = dataObj.orderType; //Ask or Bid

      let updateOrSet = function(theObj, orderType, strike, newValue){
        if (!theObj.hasOwnProperty(strike)){
          theObj[strike] = {"Bid": 0, "Ask": 0};
        }
        theObj[strike][orderType] = newValue;
      }


      if (isUser){
        updateOrSet(this.userValues, orderType, strike, newValue);
        if (dataObj.hasOwnProperty("delay")){
          return;
        }
        let userSums = Object.assign({}, this.state.userSums);
        userSums[orderType] = calculateSums(this.userValues, orderType);
        this.setState({userSums});
      } else {
        updateOrSet(this.orderBookValues, orderType, strike, newValue);
        if (dataObj.hasOwnProperty("delay")){
          return;
        }
        let orderBookSums = Object.assign({}, this.state.orderBookSums);
        orderBookSums[orderType] = calculateSums(this.orderBookValues, orderType);
        //update auctionStrike
        this.setState({orderBookSums});
        this.updateAuctionStrike();
      }
    }

    componentDidMount() {
        //console.log("OrderbookContainer componentDidMount");
        this.aggobRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("AggOB");
        this.middlePointRef = this.props.db.child("Sessions").child(this.props.sessionid).child("ImportantData").child("SessionData");
        this.pausedRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim').child('running');
        this.valRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("orderbook");
        this.auctionRef = this.props.db.child("Sessions").child(this.props.sessionid).child("inAuction");
        //declares quip automation timer
        this.quipsTimer = setInterval(this.getQuip.bind(this), 5000);

        let strike, bid, ask;

        //this listener deals with determining if the sim is paused
        this.pausedRef.on('value', snap => {
            let rawData = snap.val();
            if (rawData) {
                this.setState({
                    paused: false
                });
            } else {
                this.setState({
                    paused: true
                });
            }
        });

        this.auctionRef.on('value', snap => {
          let inAuction = !!snap.val();
          this.setState({inAuction: inAuction});
          if (inAuction){
            this.setAuctionRowValue({"shortcutuser":true});
            this.setAuctionRowValue({"shortcut":true});
          }
        });

        //this listener deals with checking the middle bid
        //and ask points
        // this.middlePointRef.on('value', snap => {
        //   let rawData = snap.val();
        //   if (!!rawData) {
        //     var midPoints = [];
        //     //let midPoints = [];
        //     //console.log(rawData);
        //     midAsk = rawData.ask;
        //     midBid = rawData.bid;
        //     midPoints.push({
        //       midAsk: midAsk,
        //       midBid: midBid
        //     });
        //     //console.log(midAsk,midBid);
        //     this.setState({
        //       midPoints: midPoints
        //     });
        //   }
        // })

        //this listener deals with getting current strikes, bid,
        //and ask. Also deals with setting ready state
        this.aggobRef.on('value', snap => {
            let rawData2 = snap.val();
            if (rawData2) {
                //console.log(rawData);
                rawData2 = Object.assign({"1800": {"Bid":0,"Ask":0}, "2200": {"Bid":0,"Ask":0}}, rawData2)
                var range = Object.keys(rawData2).map(y=>parseInt(y))
                var min = Math.min.apply(null, range)
                var max = Math.max.apply(null, range)
                var masterObj={}
                Array(((max-min)/5) + 1).fill().map((_,i)=> min + i*5).map(akey=>{masterObj[akey] = {Strike: akey.toString(), Bid: 0, Ask: 0}})
                var rawData = Object.assign(masterObj, rawData2);

                var tempStrikes = [];
                var ords = [];
                for (var key in rawData) {
                    //rawStrike = key;
                    strike = (key / 100).toFixed(2);
                    tempStrikes.push(strike);
                    bid = rawData[key].Bid;
                    if (bid === undefined) {
                        bid = 0;
                    }
                    ask = rawData[key].Ask;
                    if (ask === undefined) {
                        ask = 0;
                    }
                    if (bid === 0) {
                        bid = "";
                    }
                    if (ask === 0) {
                        ask = "";
                    }
                    ords.push({
                        "Strike": strike,
                        "Bid": bid,
                        "Ask": ask
                    });
                    /*    let strike = dataObj.strike;
                          let isUser = dataObj.isUser;
                          let newValue = dataObj.newValue;
                          let orderType = dataObj.orderType;*/
                    this.setAuctionRowValue({strike: strike, isUser: false, newValue: bid, orderType: "Bid", delay: true});
                    this.setAuctionRowValue({strike: strike, isUser: false, newValue: ask, orderType: "Ask", delay: true});
                }
                this.strikes = tempStrikes;
                this.setState({
                    orders: ords.reverse(),
                    ready: true
                });
                this.setAuctionRowValue({shortcut: true});
                this.props.onReady();
            } else {
                //var ords = [];
                this.setState({
                    orders: ords,
                    ready: false
                });
            }
        })
    }

    componentWillUnmount() {
        //console.log("OrderbookContainer componentWillUnmount");
        clearInterval(this.quipsTimer);
        this.aggobRef.off();
        this.middlePointRef.off();
        this.pausedRef.off();
        this.auctionRef.off();
    }

    wasScrolled(){
      this.setState({focused: true});
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */
    render() {
        //console.log("OrderbookContainer render");
        //console.log(this.state.userSums);
        return (
            <div className="orderBookContainerStyle">
                <div className="auctionHeader">
                  {this.state.inAuction &&
                    <h3>Call Auction is LIVE</h3>
                  }
                  <div className={`${(!this.state.inAuction ? 'hidden' : '')} auctionOnlyInput`}>
                    <label for="isAuctionOnly">New Orders <span>{this.state.auctionOnly ? "ARE" : "NOT"}</span> Auction-Only </label>
                  </div>
                </div>
                {!this.state.inAuction &&
                  <MarketOrders
                    institution={this.props.institution}
                    paused={this.state.paused}
                    uid={this.props.uid}
                    db={this.props.db}
                    sessionid={this.props.sessionid}
                  />
                }
                <Table className='orderBookTableStyle'>
                    <TableHead className='orderBookHeader'>
                    <TableRow className='orderBookRow'>
                        <TableCell className='orderBookCell bidInput'>Limit Bid</TableCell>
                        <TableCell className='orderBookCell bid'>Bids</TableCell>
                        <TableCell className='orderBookCell strike'>Price</TableCell>
                        <TableCell className='orderBookCell ask'>Asks</TableCell>
                        <TableCell className='orderBookCell askInput'>Limit Ask</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody className='orderBookTableBody'>
                    {this.state.ready
                        ?
                        this.state.orders.map(function (ord, index) {
                            return (
                                <OrderBookRow
                                    institution={this.props.institution}
                                    paused={this.state.paused}
                                    key={`${JSON.stringify(ord.Strike)}:${index}`}
                                    uid={this.props.uid}
                                    db={this.props.db}
                                    sessionid={this.props.sessionid}
                                    Bid={((this.state.inAuction) ? ( (this.state.orderBookSums.Bid.hasOwnProperty(ord.Strike)) ? this.state.orderBookSums.Bid[ord.Strike] : "") : ord.Bid)}
                                    Strike={ord.Strike}
                                    highlight={this.state.auctionStrike == ord.Strike}
                                    StartCenter={!this.state.focused && this.state.LastPrice == ord.Strike}
                                    WasScrolled={this.wasScrolled.bind(this)}
                                    Ask={((this.state.inAuction) ? ( (this.state.orderBookSums.Ask.hasOwnProperty(ord.Strike)) ? this.state.orderBookSums.Ask[ord.Strike] : "") : ord.Ask)}
                                    inAuction = {this.state.inAuction}
                                    reportChange = {this.setAuctionRowValue.bind(this)}
                                    auctionUserBid = {((this.state.inAuction) ? ( (this.state.userSums.Bid.hasOwnProperty(ord.Strike)) ? this.state.userSums.Bid[ord.Strike] : "") : "")}
                                    auctionUserAsk = {((this.state.inAuction) ? ( (this.state.userSums.Ask.hasOwnProperty(ord.Strike)) ? this.state.userSums.Ask[ord.Strike] : "") : "")}
                                    isAuctionOnly={this.state.inAuction && this.state.auctionOnly} /* When auction ON then use user preference (defaulting to true) else use FALSE */
                                    />
                            );
                        }.bind(this))
                        :
                        <TableRow>
                            <div>
                                {this.state.quip}
                            </div>
                        </TableRow>
                    }
                    </TableBody>
                </Table>
            </div>
        );
    }
}

OrderbookContainer.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default OrderbookContainer;



// WEBPACK FOOTER //
// ./src/components/Orderbook/OrderbookContainer.js